module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "microsoft-logo.c73d8dca.svg";